export default function Link (theme: any) {
  return {
    MuiLink: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[70],
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 700,
          marginRight: '7px',
          '&:hover': {
            color: theme.palette.grey[50]
          }
        }
      }
    }
  }
}
